import { gql } from '@urql/core';

export const GET_PRODUCT_QUESTIONS = gql`
  query GetProductQuestions($productId: ID!, $options: ProductQuestionListOptions) {
    productQuestions(productId: $productId, options: $options) {
      items {
        id
        createdAt
        productId
        customerId
        questionText
        state
        helpfulCount
        answerCount
        answeredAt
        customerName
        productName
        answers {
          id
          createdAt
          authorType
          authorId
          answerText
          helpfulCount
          state
          authorName
        }
      }
      totalItems
    }
  }
`;

export const ANSWER_PRODUCT_QUESTION = gql`
  mutation AnswerProductQuestion($questionId: ID!, $answerText: String!) {
    answerProductQuestion(questionId: $questionId, answerText: $answerText) {
      success
      errorCode
      answer {
        id
        answerText
        authorType
        authorName
        state
      }
    }
  }
`;

export const ANSWER_PRODUCT_QUESTION_WITH_VISIBILITY = gql`
  mutation AnswerProductQuestionWithVisibility(
    $questionId: ID!
    $answerText: String!
    $visibility: String!
  ) {
    answerProductQuestionWithVisibility(
      questionId: $questionId
      answerText: $answerText
      visibility: $visibility
    ) {
      success
      errorCode
      question {
        id
        responseMode
        privateAnsweredAt
      }
      answer {
        id
        answerText
        authorType
        authorName
        state
      }
    }
  }
`;

export const MODERATE_QUESTION = gql`
  mutation ModerateQuestion($questionId: ID!, $action: String!) {
    moderateQuestion(questionId: $questionId, action: $action) {
      success
      errorCode
      question {
        id
        state
      }
    }
  }
`;

export const MODERATE_ANSWER = gql`
  mutation ModerateAnswer($answerId: ID!, $action: String!) {
    moderateAnswer(answerId: $answerId, action: $action) {
      success
      errorCode
      answer {
        id
        state
      }
    }
  }
`;

export const GET_PRODUCT_FAQS_ADMIN = gql`
  query GetProductFaqsAdmin($productId: ID!) {
    productFaqsAdmin(productId: $productId) {
      id
      createdAt
      productId
      sortOrder
      isPublished
      question
      answer
      translations {
        id
        languageCode
        question
        answer
      }
    }
  }
`;

export const CREATE_PRODUCT_FAQ = gql`
  mutation CreateProductFaq($input: CreateProductFaqInput!) {
    createProductFaq(input: $input) {
      id
      question
      answer
      sortOrder
      isPublished
      translations {
        id
        languageCode
        question
        answer
      }
    }
  }
`;

export const UPDATE_PRODUCT_FAQ = gql`
  mutation UpdateProductFaq($id: ID!, $input: UpdateProductFaqInput!) {
    updateProductFaq(id: $id, input: $input) {
      id
      question
      answer
      sortOrder
      isPublished
      translations {
        id
        languageCode
        question
        answer
      }
    }
  }
`;

export const DELETE_PRODUCT_FAQ = gql`
  mutation DeleteProductFaq($id: ID!) {
    deleteProductFaq(id: $id)
  }
`;

export const REORDER_PRODUCT_FAQS = gql`
  mutation ReorderProductFaqs($productId: ID!, $orderedIds: [ID!]!) {
    reorderProductFaqs(productId: $productId, orderedIds: $orderedIds)
  }
`;

export const GET_ALL_QUESTIONS = gql`
  query GetAllQuestions($options: AllQuestionsOptions) {
    allQuestions(options: $options) {
      items {
        id
        createdAt
        productId
        customerId
        questionText
        state
        helpfulCount
        answerCount
        answeredAt
        responseMode
        privateAnsweredAt
        privateAnsweredBy
        customerName
        productName
        answers {
          id
          createdAt
          authorType
          authorId
          answerText
          helpfulCount
          state
          authorName
        }
      }
      totalItems
    }
  }
`;

export const GET_QA_STATS = gql`
  query GetQAStats($productId: ID) {
    qaStats(productId: $productId) {
      totalQuestions
      pendingQuestions
      answeredQuestions
    }
  }
`;

export const GET_QA_SETTINGS = gql`
  query GetQASettings {
    qaSettings {
      id
      qaEnabled
      autoApproveQuestions
      notifyMerchantOnQuestion
      notifyCustomerOnAnswer
    }
  }
`;

export const UPDATE_QA_SETTINGS = gql`
  mutation UpdateQASettings($input: UpdateQASettingsInput!) {
    updateQASettings(input: $input) {
      id
      qaEnabled
      autoApproveQuestions
      notifyMerchantOnQuestion
      notifyCustomerOnAnswer
    }
  }
`;

export const BULK_MODERATE_QUESTIONS = gql`
  mutation BulkModerateQuestions($ids: [ID!]!, $action: String!) {
    bulkModerateQuestions(ids: $ids, action: $action) {
      success
      count
    }
  }
`;
